import { Box } from '@mui/material';
import BaseDialog from '../ui/BaseDialog';

interface MessageDialogProps {
    isOpen: boolean;
    dialogTitle: string;
    message: string;
    onClose: () => void;
}

export default function MessageDialog({ isOpen, dialogTitle, message, onClose }: MessageDialogProps) {
    return (
        <BaseDialog open={isOpen} dialogTitle={dialogTitle} onClose={onClose}>
            <Box sx={{ mt: 2 }}>{message}</Box>
        </BaseDialog>
    );
}
